<template>
  <div class="ai-settings-menu">
    <el-scrollbar class="ai-settings-menu__scrollbar">
      <nav aria-label="设置菜单">
        <section v-for="group in visibleGroups" :key="group.alias" class="ai-settings-menu__group">
          <div class="ai-settings-menu__title">
            <span>{{ group.name }}</span>
          </div>
          <button
            v-for="item in group.subMenuList"
            :key="item.alias"
            class="ai-settings-menu__item"
            :class="{ active: activeAlias === item.alias }"
            :title="item.name"
            type="button"
            @click="emits('select', item)"
          >
            <i aria-hidden="true" class="t-iconfont" :class="iconMap[item.alias] || item.icon"></i>
            <span>{{ item.name }}</span>
          </button>
        </section>
      </nav>
    </el-scrollbar>
    <template v-if="visibleGroups.length">
      <AiMenuIniting
        v-if="[1, 2, 3].includes(appStore.isAiInitialization)"
        class="ai-settings-menu__setup"
      />
      <AiMenuSetting v-else-if="appStore.aiInitIsCompleted === 0" class="ai-settings-menu__setup" />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/useAppStore'
import AiMenuIniting from '../../ai-menu/ai-menu-initing.vue'
import AiMenuSetting from '../../ai-menu/ai-menu-setting.vue'

defineOptions({ name: 'AiSettingsMenu' })
const props = defineProps({
  menuList: { type: Array, default: () => [] },
  activeAlias: { type: String, default: '' }
})
const emits = defineEmits(['select'])
const appStore = useAppStore()
const visibleGroups = computed(() => props.menuList.filter((item) => item.subMenuList?.length))
const iconMap = {
  assistantManagement: 'icon-chat-smile-ai-line',
  staffTrainConfiguration: 'icon-building-line1',
  dataSourceManagement: 'icon-bar-chart-box-ai-line',
  permissionManagement: 'icon-admin-line1',
  usageDetailsPermission: 'icon-ai-generate-2'
}
</script>

<style lang="scss" scoped>
.ai-settings-menu {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: 0 12px;

  &__scrollbar {
    flex: 1;
    height: 0;
    min-height: 0;
  }

  .ai-settings-menu__setup {
    flex-shrink: 0;
    padding: 12px 0 0;
  }

  button {
    width: 100%;
    padding: 6px 12px;
    border: 0;
    background: transparent;
    font-family: inherit;
    font-weight: 400;
    text-align: left;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid #7a52f4;
    outline-offset: -2px;
  }

  &__group + &__group {
    margin-top: 12px;
  }

  &__title {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    font-size: 12px;
    line-height: 18px;
    color: #858e9f;
  }

  &__item {
    display: flex;
    align-items: center;
    margin-top: 2px;
    border-radius: 12px;
    color: #242832;
    font-size: 14px;
    line-height: 22px;

    .t-iconfont {
      flex: 0 0 16px;
      margin-right: 12px;
      font-size: 16px;
      line-height: 16px;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover,
    &.active {
      background: #e1e1e1;
    }
  }
}
</style>
